/**
 * Gold "MAX" pill (EPIC-07). Styling lives in App.css (.max-badge) on the
 * --color-max-* tokens so light and dark stay in sync. Gold is an accent
 * only: the badge is small and never repaints its surroundings.
 */
export default function MaxBadge({ className = '' }: { className?: string }) {
  return <span className={`max-badge ${className}`.trim()}>MAX</span>;
}
